module.exports = __webpack_public_path__ + "img/ico-hide.a32d93ce.svg";